import { INavigatorAction, NavigatorActionCodec, NavigatorActionType } from '@engoo/realtime-protocol/navigator';
import { IPersistedAction, PersistedActionCodec, makeStreamPosition } from '@engoo/realtime-protocol/persisted';
import { OrderedMap, Record } from 'immutable';
import { pipe } from 'fp-ts/lib/pipeable';
import { fold } from 'fp-ts/lib/Either';
import { makeTimestamp } from '@engoo/realtime-protocol/util/timeSchemas';
import * as iots from 'io-ts';

export type NavigatorState = OrderedMap<number, NavigationChange>;

type PersistedNavigationAction = INavigatorAction & IPersistedAction;

export class NavigationChange extends Record<PersistedNavigationAction>({
  position:  makeStreamPosition(0),
  tag:       undefined,
  timestamp: makeTimestamp(0),
  type:      NavigatorActionType.Navigate,
  url:       '',
  user:      '',
}) {}

const PersistedNavigatorCodec = iots.intersection([
  PersistedActionCodec,
  NavigatorActionCodec,
]);

export const navigatorReducer = (state: NavigatorState = OrderedMap(), action?: unknown): NavigatorState => {
  return pipe(
    PersistedNavigatorCodec.decode(action),
    fold(
      // Not a navigator action, simply return the state as was.
      // Ignore non-persisted actions too
      () => {
        return state;
      },
      (navigatorAction) => {
        const { position } = navigatorAction;
        return state.set(position, new NavigationChange(navigatorAction));
      },
    ),
  );
};

export const navigatorActionHandler = ({ apply: navigatorReducer });
